import OBJFileIcon from 'components/Icons/OBJFileIcon'
import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { openFreshPartFile } from 'store/actions'

export const ObjDownloader = ({ partId, t }) => {
	const dispatch = useDispatch()
	const url = useSelector(state =>
		(/** @type {StoreState} */(state)).CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === partId)?.fileLinks?.objModel
	)
	const tooltipId = partId + '_obj'

	return (
		<div>
			{url ?
				<div className="cursor" onClick={() => dispatch(openFreshPartFile(partId, 'objModel', url))} data-tip={t('download_obj', { ns: 'naming' })} data-for={tooltipId}>
					<OBJFileIcon tooltipMessage={t('download_obj', { ns: 'naming' })} />
				</div> :
				<div>

				</div>
			}
			<ReactTooltip
				id={tooltipId}
				place="top"
				type="info"
				effect="solid"
				multiline={false}
			/>
		</div>)
}

ObjDownloader.propTypes = {
	partId: PropTypes.number,
	t: PropTypes.func,
}

export default withTranslation()(ObjDownloader)
